import React from 'react'

const AccountCard = ({ buttonName, content, title }) => {
    return (
        <div className='py-12 flex justify-between border-y'>
            <div>
                <h5>{title}</h5>
                <p className='my-0 font-normal text-gray-600 text-xl'>{content}</p>
            </div>
            <div>
                {buttonName &&
                    <button className="p-3 border rounded-lg  text-blue-700 text-ms font-medium hover:text-white hover:bg-blue-700">{buttonName}</button>
                }
            </div>
        </div>
    )
}

export default AccountCard